export const insertChipForMentionTag = (
  mentionTag: string,
  uuid?: string,
  needTrailingSpace = true,
) =>
  `<span id="${uuid}" contenteditable="false" class="mention-tag-chip-container"><span class="mention-tag-chip" contenteditable="false">${mentionTag}</span></span>${
    needTrailingSpace ? ' ' : ''
  }`;

export const CATEGORY_VALUE_LABEL_MAP: Record<string, string> = {
  upcoming: 'Enrollment Pending',
};
